import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';
import ColorBox from './components/ColorBox';
import ChartBox from './components/ChartBox';
import ColorFilter from './components/ColorFilter';
import ChartFilter from './components/ChartFilter';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import ExportModal from './components/ExportModal';
import { colorBox, chartBox, ColorParams, ChartParams } from '../constants/people';
import moment from 'moment';

const FinExportType = {
    financeIncome: 'FinanceAnalysis',
};

class Dashboard extends Component {
    static contextTypes = {
        activeKey: PropTypes.string,
        systemDate: PropTypes.object
    }

    constructor(props, context) {
        super(props);
        const { activeKey, systemDate } = context;
        const colorParams = {...ColorParams[activeKey]};
        colorParams.date =  parseInt(moment(systemDate.date).format('DD')) < 26 ? 
            moment(systemDate.date).add( -1, 'M').format('YYYY-MM') : systemDate.monthDate;
        const chartParams = {...ChartParams[activeKey]};
        chartParams.year = systemDate.year;
        this.state = {
            refreshColor: null,
            refreshChart: null,
            colorParams,
            chartParams
        };
    }

    handleExport = (type) => {
        const { activeKey } = this.context;
        const params = this.state[`${type}Params`];
        const { areaParams, statisticDate, hasCheckedArea, ...rest } = params;
        const statisticsType = type === 'color' ? 'Color' : 'Graph';
        Fetch.post(API_URL.dashboard.exportFinanceAnalysis, {
            ...rest,
            ...areaParams,
            statisticsType,
            finExportType: FinExportType[activeKey]
        }).then(res => {
            message.success(res.success);
        });
    }

    handleSearch = (type) => {
        this.setState({ [`refresh${type.replace(/^\w/, m => m.toUpperCase())}`]: {} });
    }

    handleChange = (value, type) => {
        this.setState({ [`${type}Params`]: value });
    }

    showExport = ( type, params) => {
        this.exportModalRef.show(type, params)
    }

    render() {
        const { activeKey } = this.context;
        const { colorParams, refreshColor, chartParams, refreshChart } = this.state;
        const colorNotShow = colorParams.lineOfBusiness != '-1' || colorParams.investigationAreaId;
        const chartNotShow = chartParams.lineOfBusiness != '-1' || chartParams.investigationAreaId;
        return (
            <div>
                <ColorFilter
                    params={colorParams}
                    onExport={() => this.showExport('color', colorParams)}
                    onSearch={() => this.handleSearch('color')}
                    onChange={value => this.handleChange(value, 'color')}
                />
                <div className="colorWrap">
                    {
                        colorBox[activeKey].map(item => {
                            if( !(colorNotShow && item.allBusiness) ) {
                                return (
                                    <ColorBox
                                        {...item}
                                        key={item.moduleType}
                                        params={colorParams}
                                        refresh={refreshColor}
                                    />
                                );
                            }
                        })
                    }
                </div>
                <ChartFilter
                    params={chartParams}
                    onExport={() => this.showExport('chart', chartParams)}
                    onSearch={() => this.handleSearch('chart')}
                    onChange={value => this.handleChange(value, 'chart')}
                    subTabActiveKey={this.props.subTabActiveKey}
                />
                <ExportModal ref={ el => this.exportModalRef = el}/>
                <div className="flexBox">
                    {
                        chartBox[activeKey].map(item => {
                            if( !(chartNotShow && item.allBusiness) ) {
                                return (
                                    <ChartBox
                                        {...item}
                                        key={item.moduleType}
                                        params={chartParams}
                                        refresh={refreshChart}
                                    />
                                );
                            }
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/homePage/personIndicatorAnalysis/Dashboard.js